
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import HomeList from '../components/home/HomeList'

const swiperList = [{
  url: 'javascript:',
  // img: 'http://app.ecms.gczj.com.cn/assets/app/src/assets/banner/banner1.png',
  img: require('../assets/banner/banner1.png'),
  title: ''
}]

export default {
  components: {
    HomeList,
    Group,
    Cell,
    XHeader,
    Swiper
  },
  data () {
    return {
      pageTitle: '',
      swiperData: swiperList,
      userName: false
    }
  },
  mounted: function () {
    console.log('进入home')
    this.showBackData = true
    let stateUrl = this.$store.state.url
    if (stateUrl === '') {
      // this.$store.state.url = window.parent.document.getElementById('hostAddress').value
      const hostAddressEL = window.parent.document.getElementById('hostAddress')
      if (hostAddressEL != null && (hostAddressEL.value != null || hostAddressEL.value != undefined)) {
        this.$store.state.url = hostAddressEL.value
      }
      this.getUser()
    } else {
      this.getUser()
    }
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login' })
    },
    getUser () {
      // this.$vux.loading.show({
      //   text: '加载中'
      // })
      const url = this.$store.state.url + '/wechat/login/user'
      this.$http.get(url).then(({ data }) => {
        if (data && data.account) {
          this.userName = data.account.accounts
          // console.log('home.token:' + data.token)
          this.$store.commit('setTokenVal', data.token)
          // console.log('home.openid:' + data.account.openid)
          this.$store.commit('setOpenIdVal', data.account.openid)
        }
        // if (response.data.account) {
        //   this.$store.state.userInfo = response.data.account
        //   this.$store.state.openId = response.data.account.openid
        //   this.userName = response.data.account.accounts
        // }
        // if (response.data.token && response.data.success === true) {
        //   console.log('home.token:' + response.data.token)
        //   this.$store.commit('setTokenVal', response.data.token)
        // }
        // if (response.data.account.openid && response.data.success === true) {
        //   console.log('home.openid:' + response.data.account.openid)
        //   this.$store.commit('setOpenIdVal', response.data.account.openid)
        // }
        if (this.$store.state.token === '' && this.$store.state.openId === '') { // 如果未绑定，获取微信openId
          this.getOpenId()
        }
      }).catch((response) => {
        console.log(response)
      })
      // this.axios({
      //   url: this.$store.state.url + '/wechat/login/user',
      //   method: 'get'
      // })
    },
    getOpenId () {
      let openidUrl = window.location.href
      let openidStr
      // 验证地是否有openid
      if (openidUrl.indexOf('openid') !== -1) { // 必须经过微信认证中心跳转才会有openid
        let fromPos = openidUrl.indexOf('=')
        openidStr = openidUrl.substr(fromPos + 1)
        this.$store.state.openId = openidStr
      } else {
        window.location.href = this.$store.state.url + '/wechat/login'  // 正式环境登录地址
        // this.goLogin()  // 开发环境登录地址
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Home.vue